import { useCallback } from 'react';
import { pick, prop } from 'ramda';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { useGetTemporaryAuthenticationToken as useGetTemporaryAuthenticationTokenRequest } from 'server';

export const useGetTemporaryAuthenticationToken = () => {
    const casinoName = useAppSelector(prop('casinoName'));
    const { userName, sessionToken } = useUserSelector(pick(['userName', 'sessionToken']));
    const getTemporaryAuthenticationToken = useGetTemporaryAuthenticationTokenRequest();

    return useCallback(async (serviceType = 'GamePlay') => {
        const { token } = await getTemporaryAuthenticationToken({
            userName, casinoName, serviceType, sessionToken
        });

        return token;
    }, [
        casinoName,
        getTemporaryAuthenticationToken,
        sessionToken,
        userName
    ]);
};
